/*
 * Timezone-correct helpers that produce ISO strings anchored to the user's
 * local midnight — not UTC midnight. `new Date(y, m, d)` constructs a local
 * midnight; `.toISOString()` encodes it as UTC, preserving the intended
 * moment-in-time regardless of the user's offset.
 */

export const todayLocalMidnightIso = () => {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate()).toISOString();
};

export const tomorrowLocalMidnightIso = () => {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate() + 1).toISOString();
};

export const daysAgoLocalMidnightIso = (days) => {
  const n = new Date();
  return new Date(n.getFullYear(), n.getMonth(), n.getDate() - days).toISOString();
};
